import {
  createUserWithEmailAndPassword,
  deleteUser,
  sendEmailVerification,
  sendPasswordResetEmail,
  signInWithEmailAndPassword,
  signOut,
} from "firebase/auth";
import { appAuth } from "../firebase";
import { updateProfile } from "firebase/auth";
import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import { userStateSelector } from "../store/user";
import { useUser } from "./database/useUser";

export const useAuth = () => {
  const currentUser = appAuth.currentUser;
  const [user, setUser] = useRecoilState(userStateSelector);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");
  const { getCloudUser, setCloudUser } = useUser();

  useEffect(() => {
    // 회원가입 | 로그인
    // user에 firebase auth 할당
    if (!success) return;

    if (currentUser && !user.uid) {
      getCloudUser(currentUser.uid).then(async (cloudUser) => {
        // console.log(cloudUser);
        const lastUser = {
          ...cloudUser,
          email: currentUser.email || "",
          emailVerified: currentUser.emailVerified,
        };
        await setUser(() => lastUser);
        localStorage.setItem("user", JSON.stringify(lastUser));
      });
    }
  }, [success]);

  useEffect(() => {
    // 새로고침
    const localUser = window.localStorage.getItem("user");
    if (!user.uid && localUser) {
      setUser(JSON.parse(localUser));
    }
  }, [user.uid]);

  const signup = (username: string, email: string, password: string) => {
    createUserWithEmailAndPassword(appAuth, email, password)
      .then(async (userCredential) => {
        const user = userCredential.user;
        await updateProfile(user, { displayName: username }).catch((err) =>
          console.log(err)
        );
        sendEmailVerification(user).then(() => {});
        await setCloudUser(user.uid, user.displayName || "");
        setSuccess(true);
      })
      .catch((error) => {
        switch (error.code) {
          case "auth/weak-password":
            setError("비밀번호는 6자리 이상이어야 합니다");
            break;
          case "auth/invalid-email":
            setError("잘못된 이메일 주소입니다");
            break;
          case "auth/email-already-in-use":
            setError("이미 가입되어 있는 계정입니다");
            break;
        }
      });
  };

  const login = (email: string, password: string) => {
    signInWithEmailAndPassword(appAuth, email, password)
      .then(async (userCredential) => {
        const user = userCredential.user;
        setSuccess(true);
      })
      .catch((error) => {
        switch (error.code) {
          case "auth/invalid-email":
            setError("옳지않은 이메일 입니다");
            break;
          case "auth/user-not-found":
            setError("존재하지 않는 이메일이거나 잘못된 비밀번호 입니다");
            break;
          case "auth/wrong-password":
            setError("존재하지 않는 이메일이거나 잘못된 비밀번호 입니다");
            break;
        }
      });
  };

  const updatePassword = (email: string) => {
    sendPasswordResetEmail(appAuth, email)
      .then(() => {
        // Password reset email sent!
        // ..
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        // ..
      });
  };

  const updateUser = (username: string) => {
    if (!appAuth.currentUser) return;
    updateProfile(appAuth.currentUser, {
      displayName: username,
    })
      .then(() => {
        // Profile updated!
        // ...
      })
      .catch((error) => {
        // An error occurred
        // ...
      });
  };

  const delUser = () => {
    const user = appAuth.currentUser;
    if (!user) return;
    deleteUser(user)
      .then(() => {
        // User deleted.
      })
      .catch((error) => {
        // An error ocurred
        // ...
      });
  };

  // const loginWithGoogle = () => {
  //   signInWithPopup(appAuth, provider)
  //     .then((result) => {
  //       // This gives you a Google Access Token. You can use it to access the Google API.
  //       const credential = GoogleAuthProvider.credentialFromResult(result);
  //       const token = credential?.accessToken;
  //       // The signed-in user info.
  //       const user = result.user;
  //       console.log(user);
  //       // ...
  //     })
  //     .catch((error) => {
  //       // Handle Errors here.
  //       const errorCode = error.code;
  //       const errorMessage = error.message;
  //       // The email of the user's account used.
  //       const email = error.customData.email;
  //       // The AuthCredential type that was used.
  //       const credential = GoogleAuthProvider.credentialFromError(error);
  //       // ...
  //     });

  //   signInWithRedirect(appAuth, provider);

  //   getRedirectResult(appAuth)
  //     .then((result) => {
  //       // This gives you a Google Access Token. You can use it to access Google APIs.
  //       const credential = GoogleAuthProvider.credentialFromResult(result!);
  //       const token = credential?.accessToken;

  //       // The signed-in user info.
  //       const user = result?.user;
  //       // IdP data available using getAdditionalUserInfo(result)
  //       // ...
  //     })
  //     .catch((error) => {
  //       // Handle Errors here.
  //       const errorCode = error.code;
  //       const errorMessage = error.message;
  //       // The email of the user's account used.
  //       const email = error.customData.email;
  //       // The AuthCredential type that was used.
  //       const credential = GoogleAuthProvider.credentialFromError(error);
  //       // ...
  //     });
  // };

  const signout = () => {
    signOut(appAuth)
      .then(() => {
        setUser({
          uid: "",
          username: "",
          email: "",
          emailVerified: false,
          level: 0,
          scrapAlbum: [""],
          scrapUser: [""],
          requestLevelUp: false,
          createdTime: null,
        });
        localStorage.removeItem("user");
        setSuccess(true);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return {
    currentUser,
    user,
    setUser,
    // updateCurrentUser,
    signup,
    login,
    signout,
    updateUser,
    updatePassword,
    delUser,
    error,
    success,
  };
};
